import MixPanel from "appAnalytics/mixPanel";

// ---------------------------------------------------------------------------
// ID helpers — persisted so IDs survive across calls
// ---------------------------------------------------------------------------

function getClientId() {
  const KEY = "jockey_cid";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

function getSessionId() {
  const KEY = "jockey_sid";
  let id = sessionStorage.getItem(KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(KEY, id);
  }
  return id;
}

// ---------------------------------------------------------------------------
// Main tracking function
// Fire-and-forget: errors are silently swallowed.
// ---------------------------------------------------------------------------

export function track(type, data, productId) {
  const event = {
    id:
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    clientId: getClientId(),
    sessionId: getSessionId(),
    productId: productId ? String(productId) : undefined,
    type,
    data: data || {},
    timestamp: Date.now(),
  };

  // Backend — fire-and-forget
  fetch("/proxy/cust/jockey/track", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ payload: event }),
  }).catch(() => {});

  // Mixpanel — fire-and-forget
  try {
    MixPanel.buttonClicked("Jockey_Demo", type, { ...event.data, productId: event.productId }, true);
  } catch (_) {}

  // Mirror to the host page so the storefront wrapper can persist EVERY event
  // to its own database — not just the two (measurement_complete, tab_change)
  // that already postMessage directly. On Shopify the wrapper relays TRACK_EVENT
  // into Postgres, giving us a durable, region-independent copy of the whole
  // in-experience funnel (Mixpanel prod is EU-only; this is how UAT is tracked).
  // Marked `_mirror` so the demo embed (DopplrScript) ignores it — the iframe
  // already tracks these directly there, and re-relaying would double-count.
  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        { message: "TRACK_EVENT", value: { type, ...event.data, productId: event.productId, _mirror: true } },
        "*"
      );
    }
  } catch (_) {}
}
